import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import Content from './PlannerAccountOpeningRiskToleranceContent';

const useStyles = buildUseStyles('PlannerAccountOpeningRiskToleranceTemplate', (() => ({
  root: {},
})));

const PlannerAccountOpeningRiskToleranceTemplate = ({
  className,
  resource,
}) => {
  const classes = useStyles();
  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      metaOverrideSet={BaseOverrideNoHidden}
      resource={resource}
      layout={Content}
    />
  );
};

PlannerAccountOpeningRiskToleranceTemplate.defaultProps = {
  className: '',
};

PlannerAccountOpeningRiskToleranceTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default PlannerAccountOpeningRiskToleranceTemplate;
